import { useState } from "react";
import { Transaction } from "../types/Product";

interface Option {
  value: string;
  label: string;
}

export const DEFAULT_LIST_NAME = "default_list";

export const useProductList = () => {
  const [current, setCurrent] = useState<string>(
    localStorage.getItem("currentProductList") || DEFAULT_LIST_NAME,
  );
  const [productList, setProductList] = useState(() => {
    const lists = JSON.parse(localStorage.getItem("productLists") || "[]");
    if (lists.length === 0) {
      localStorage.setItem(
        "productLists",
        JSON.stringify([{ value: DEFAULT_LIST_NAME, label: "我的清單" }]),
      );
      return [{ value: DEFAULT_LIST_NAME, label: "我的清單" }];
    }
    return lists.map((list: Option) => list);
  });

  const changeCurrentProductList = (listName: string) => {
    localStorage.setItem("currentProductList", listName);
    setCurrent(listName);
  };

  return { current, changeCurrentProductList, productList, setProductList };
};
